import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { subitem } from './subitem';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const item = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('produtos/itens/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            let subitems = [];
            if(response.data){              
              subitems = await dispatch(subitem({...filtro,iditems:response.data[0].iditems}));
            }

            dispatchresponse(dispatch,response.data,types.PRODUTOS.PESQUISA_ITEM);
            return subitems;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}